module.exports = __webpack_public_path__ + "images/accents/accent-review-discussion@1x-9e8a78243dd8e0334cbe65080596ba8a.webp";